import { render, staticRenderFns } from "./AlgFlocktory.vue?vue&type=template&id=4d29709f&scoped=true&"
import script from "./AlgFlocktory.vue?vue&type=script&lang=js&"
export * from "./AlgFlocktory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29709f",
  null
  
)

export default component.exports